module.exports = __webpack_public_path__ + "img/banner.b63e97c7.svg";